export default "__VITE_ASSET__CaYUmTU2__"